import { localStorageUtil } from '../utils/local-storage.util';

export const accessTokenStorage = localStorageUtil<string>('accessToken');
